<template>
  <div class="auth-shell">
    <header class="auth-head">
      <AppBrand />
    </header>

    <main class="auth-main">
      <div class="auth-pitch">
        <div class="auth-tagline display">Slice.<br>Build.<br><span style="color:var(--acctext);">Blast.</span></div>
        <p>Turn a finished email design into a campaign that's ready to send.</p>
      </div>
      <slot />
    </main>

  </div>
</template>

<script setup lang="ts">
// Shell for the auth screens: brand, the pitch on wide screens, and the page's card.
</script>
